/**
 * Fake news debunker InVID WeVerify VeraAI — media verification toolkit
 *
 * Its single web-accessible-resource entry exposes three files to `<all_urls>` with no
 * `use_dynamic_url`. The manifest also lists `c2paAssets/toolkit_bg.wasm`, but that file
 * is absent from the shipped package, so the two content scripts — `inject.js` and
 * `sna-bridge.js` — are the reachable paths. Both are distinctly named and fetchable
 * from any page at a fixed URL. No images are exposed, so both signals use `probeFetch`.
 *
 * Manifest verified against version 0.92.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mhccpoafgdgbhnjfhkcmgknndkeenfhe';

export const invidWeverify: ExtensionDefinition = {
  id: ID,
  name: 'Fake news debunker InVID WeVerify VeraAI',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes content-scripts/inject.js and sna-bridge.js to <all_urls> with no dynamic ' +
    'URL. No images are web-accessible, so both signals are fetches; detection is conclusive.',
  signals: [
    {
      id: 'war-inject-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/inject.js — a content script exposed to every origin at a ' +
        'fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'content-scripts/inject.js'),
    },
    {
      id: 'war-sna-bridge-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-scripts/sna-bridge.js — a distinctly named second content script, ' +
        'independent of the first.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-scripts/sna-bridge.js'),
    },
  ],
};
